import React from 'react';
import './gameUi.css';
import {getPlayerColorStyle} from '../../utils/gameUi/getPlayerColorStyle';
import {joinClassNames} from './joinClassNames';

/**
 * Портрет в рамке цвета игрока
 * @param {string} src - портрет фракции или образа
 * @param {string} [alt]
 * @param {string} [playerColor] - цвет игрока (PLAYER_COLORS) или '#rrggbb'
 * @param {number} [size] - сторона портрета в px
 * @param {boolean} [shadow] - тень вокруг портрета
 */
export function PlayerFrame({src, alt = '', playerColor, size, shadow = false, className, style, ...rest}) {
  const frame = (
    <span
      className={joinClassNames('gui-player-frame', className)}
      style={{
        ...getPlayerColorStyle(playerColor),
        ...(size ? {'--gui-frame-size': `${size}px`} : null),
        ...style,
      }}
      {...rest}
    >
      <img src={src} alt={alt}/>
    </span>
  );

  // Рамка обрезана clip-path — тень вешается на обертку
  return shadow ? <span className={'gui-player-frame-shadow'}>{frame}</span> : frame;
}

export default PlayerFrame;
